import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import BrandsContext from '../../../contexts/BrandsContext'
import PreviewContainer from '../../shared/PreviewContainer'
import { EnrollmentType } from '../../../interface/EnrollmentType'
import BusinessInformationStep from '../steps/BusinessInformationStep'
import BusinessAddressAndContact from '../steps/BusinessAddressAndContact'

type PropsType = {
    onGoBack(): unknown
    onClickEdit(id: number): unknown
    onClickSubmitPaymentFailed(id: number): unknown
}

const jss = () => {
    return {
        mb40: {
            marginBottom: 40
        }
    }
}

const useStyles = makeStyles(jss)

const Preview = ({
    onClickEdit,
    onClickSubmitPaymentFailed
}: PropsType) => {
    const styles = useStyles()
    const { brands } = useContext(BrandsContext)

    let { id } = useParams()
    id = Number.parseInt(id)

    const item = brands.find((x) => x.csp_brand_id === id)

    if (!item) {
        return 'Not found'
    }

    return <PreviewContainer
        item={item}
        titleRight={`Brand ID: ${item.csp_brand_id}`}
        enrollmentType={EnrollmentType.Brand}
    >
        <div className={styles.mb40} data-testid='brands-preview'>
            <BusinessInformationStep
                editing={item}
                passData={{}}
                onClickEdit={() => onClickEdit(id)}
                onClickSubmitPaymentFailed={() => onClickSubmitPaymentFailed(id)}
                mode='preview'
            />
        </div>
        <div className={styles.mb40}>
            <BusinessAddressAndContact
                editing={item}
                passData={{}}
                mode='preview'
            />
        </div>
    </PreviewContainer>
}

export default Preview
